import { handleActions } from "redux-actions";

import {
    getConfigsEntities,
    getConfigsEntitiesSuccess,
    getConfigsEntitiesError,
    setSelectedConfigs,
    setWorkersDialog,
    mergeWorkersDialog,
    enabledConfig,
    enabledConfigError,
    enabledCheckedConfig,
    enabledCheckedConfigError,
    deleteConfigError,
    deleteConfig,
    clearConfigs,
    setPublishRequestDialog,
    mergePublishRequestDialog,
    setSelectedDataSelectors,
    setSelectedDataNormalizers,
    setSelectedBlockSelectors,
    setSelectedTemplates
} from "./actions";

const initialState = {
    isLoading: false,
    selectedConfigs: [],
    selectedDataSelectors: [],
    selectedDataNormalizers: [],
    selectedBlockSelectors: [],
    selectedTemplates: [],
    ids: [],
    entities: {},
    publishRequestsCount: {},
    count: 0,
    workersDialog: {
        id: null,
        isOpen: false,
        isLoading: false,
        initialValues: {}
    },
    publishConfigDialog: {
        id: null,
        isOpen: false,
        isLoading: false
    },
    publishRequestDialog: {
        ids: [],
        isOpen: false
    }
};

export const entitiesReducer = handleActions(
    {
        [clearConfigs]: () => ({ ...initialState }),
        [getConfigsEntities]: (state) => ({
            ...state,
            selectedConfigs: [],
            ids: [],
            entities: [],
            count: 0,
            isLoading: true
        }),
        [getConfigsEntitiesSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getConfigsEntitiesError]: (state) => ({
            ...state,
            isLoading: false
        }),

        [enabledConfig]: (state) => ({
            ...state,
            isLoading: true
        }),
        [enabledConfigError]: (state) => ({
            ...state,
            isLoading: false
        }),

        [setSelectedConfigs]: (state, { payload }) => ({
            ...state,
            selectedConfigs: payload
        }),

        [setSelectedDataSelectors]: (state, { payload }) => ({
            ...state,
            selectedDataSelectors: payload
        }),

        [setSelectedDataNormalizers]: (state, { payload }) => ({
            ...state,
            selectedDataNormalizers: payload
        }),

        [setSelectedBlockSelectors]: (state, { payload }) => ({
            ...state,
            selectedBlockSelectors: payload
        }),

        [setSelectedTemplates]: (state, { payload }) => ({
            ...state,
            selectedTemplates: payload
        }),

        [setWorkersDialog]: (state, { payload }) => ({
            ...state,
            workersDialog: {
                ...initialState.workersDialog,
                ...payload
            }
        }),
        [mergeWorkersDialog]: (state, { payload }) => ({
            ...state,
            workersDialog: {
                ...state.workersDialog,
                ...payload
            }
        }),

        [setPublishRequestDialog]: (state, { payload }) => ({
            ...state,
            publishRequestDialog: {
                ...initialState.publishRequestDialog,
                ...payload
            }
        }),
        [mergePublishRequestDialog]: (state, { payload }) => ({
            ...state,
            publishRequestDialog: {
                ...state.publishRequestDialog,
                ...payload
            }
        }),

        [enabledCheckedConfig]: (state) => ({
            ...state,
            isLoading: true
        }),
        [enabledCheckedConfigError]: (state) => ({
            ...state,
            isLoading: false
        }),

        [deleteConfig]: (state) => ({
            ...state,
            isLoading: true
        }),
        [deleteConfigError]: (state) => ({
            ...state,
            isLoading: false
        })
    },
    initialState
);
